import type { InstitutionIconProps } from "@design-system/InstitutionIcon/InstitutionIcon";
import { ResolvedInstitutionIcon } from "@design-system/InstitutionIcon/ResolvedInstitutionIcon";
import {
    resolveInstitutionIcon,
    type InstitutionIconAccount,
    type InstitutionIconConnection,
} from "./resolveInstitutionIcon";

interface AccountInstitutionIconProps extends Pick<
    InstitutionIconProps,
    "size" | "label" | "className"
> {
    account: InstitutionIconAccount;
    /** Not derived from the account; pass `getLeadingAccountConnection(account)` to match `AccountCard`. */
    connection?: InstitutionIconConnection | null;
}

/**
 * The bank or provider logo for a financial account, resolved by
 * `resolveInstitutionIcon`. Manual accounts show a dollar glyph; accounts
 * without a known logo show the bank glyph.
 */
export const AccountInstitutionIcon = ({
    account,
    connection,
    ...iconProps
}: Readonly<AccountInstitutionIconProps>) => (
    <ResolvedInstitutionIcon
        {...iconProps}
        icon={resolveInstitutionIcon({ account, connection })}
    />
);
